import { LOADING, MEETING_TYPES } from "../actionType/meetingType";
import { meetingTypes } from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";

export const createMeetingType = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return postAuthMethod(meetingTypes, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const updateMeetingType = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return putAuthMethod(meetingTypes, payload?.meetingTypeId, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getMeetingTypes = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(meetingTypes)
    .then((res) => {
      dispatch({
        type: MEETING_TYPES,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const deleteMeetingType = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return deleteAuthMethod(`${meetingTypes}/${id}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};
